<template>
  <div>
    <OtherHeader :img_header="header_image" header="ตั้งค่าเว็บไซต์อื่นๆ" link_back="managewebsite"/>
    <MenuOther/>
    <Logo_page/>
  </div>
</template>

<script>
import HeaderImage from "@/assets/logo_img.png";
import OtherHeader from "@/components/admin/manage_website/other_setting/menu_other/OtherHeader";
import MenuOther from "@/components/admin/manage_website/other_setting/menu_other/MenuOther";
import Logo_page from "@/components/admin/manage_website/other_setting/Logo_page";

export default {
  name: "LogoPage",
  components: {
    Logo_page,
    MenuOther,
    OtherHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
